import React from "react";
import { colors } from "@zapalacorp/tokens";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height?: number;
  width?: number;
  color?: string;
}

export function IconCustomTeam(props: SvgComponentProps) {
  const { width = 16, height = 16, color = colors.gray500 } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox="0 0 123 108"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.6 3.33332C16.0666 6.13332 12.3333 12.8 12.3333 18.1333C12.3333 19.6 13.4 23.0667 14.6 25.6C20.3333 37.8667 38.6 38.6667 45.6666 26.9333C55.2666 11.3333 36.4666 -6.26668 20.6 3.33332ZM40.0666 9.33332C43.5333 13.3333 44.0666 21.3333 41 25.4667C38.4666 29.2 31.8 31.8667 27.5333 30.8C19.6666 28.8 15.1333 18.5333 19 11.3333C22.8666 4.13332 34.6 3.06666 40.0666 9.33332Z"
          fill={color}
        />
        <path
          d="M70.8667 3.73332C67.8 5.73332 65.8 8.66665 64.4667 12.4C62.8667 17.4667 63 18.9333 65 24C69.6667 36.4 84.3334 39.2 93.2667 29.4667C96.8667 25.4667 97.6667 23.6 97.6667 18.5333C97.6667 15.2 96.7334 10.8 95.5334 8.66665C90.6 0.533319 79.1334 -1.86668 70.8667 3.73332ZM86.0667 6.13332C89.9334 7.86665 93.6667 13.8667 93.6667 18.4C93.6667 22.8 88.0667 29.4667 83.4 30.5333C73.6667 33.0667 64.7334 20.5333 69.6667 11.3333C71.2667 8.39999 77.2667 4.79999 80.6 4.66665C81.8 4.66665 84.3334 5.33332 86.0667 6.13332Z"
          fill={color}
        />
        <path
          d="M89.5333 46.6666C72.6 63.7333 71.5333 65.2 69.1333 73.3333C65.5333 85.8666 66.0667 86.5333 77.9333 82.8C87.2667 79.8666 88.3333 79.0666 103.8 63.8666C120.867 47.2 123.667 43.4666 122.333 39.3333C121.267 35.8666 112.733 28.6666 109.8 28.6666C108.6 28.6666 99.4 36.8 89.5333 46.6666ZM114.6 36.9333C118.333 40.4 118.467 43.4666 115.267 46.5333C112.867 48.5333 112.467 48.4 108.6 44C103.933 38.9333 103.533 38 105.933 35.6C108.333 33.2 111.133 33.6 114.6 36.9333ZM104.867 46.8L109 51.6L96.7333 63.8666C87.6667 72.9333 83 76.6666 78.8667 77.8666C75.9333 78.8 73.1333 79.3333 72.8667 79.0666C72.6 78.8 73 76.1333 73.8 73.2C74.8667 69.4666 78.6 64.4 87.4 55.2C94.2 48.1333 99.9333 42.2666 100.2 42.1333C100.467 42.1333 102.6 44.1333 104.867 46.8Z"
          fill={color}
        />
        <path
          d="M48.8666 34.5333C40.3333 38.2666 35.9333 51.0666 40.3333 59.3333C42.8666 64 49.6666 67.3333 56.7333 67.3333C74.2 67.3333 79.8 44.2666 64.4666 35.6C58.6 32.2666 54.7333 32 48.8666 34.5333ZM64.2 40.8C70.7333 46.9333 70.7333 54.4 64.0666 60C58.8666 64.4 52.3333 64.4 47.4 60.1333C44.3333 57.4666 43.6666 55.8666 43.6666 50.6666C43.6666 45.4666 44.3333 43.8666 47.4 41.2C52.2 37.0666 59.9333 36.9333 64.2 40.8Z"
          fill={color}
        />
        <path
          d="M11 40.4C4.06665 44 0.333313 52.2666 0.333313 64C0.333313 69.0666 1.13331 74.8 2.06665 76.6666C3.53331 79.7333 4.73331 80 14.2 80.6666C19.9333 81.0666 25.2666 80.9333 26.0666 80.4C29.2666 78.4 24.8666 76.8 15.6666 76.4L6.33331 76L5.93331 64.6666C5.66665 55.3333 6.06665 52.5333 8.19998 49.0666C11.4 44 18.4666 41.6 29.5333 42.1333C35.6666 42.4 37.1333 42.1333 37.4 40.2666C37.8 38.2666 36.4666 38 26.7333 38C18.6 38 14.3333 38.6666 11 40.4Z"
          fill={color}
        />
        <path
          d="M74.6 38.9333C72.2 41.3333 74.4667 42.1333 82.6 41.7333C88.2 41.4667 91.6667 40.6667 92.0667 39.6C92.4667 38.4 90.2 38 84.0667 38C79.2667 38 75 38.4 74.6 38.9333Z"
          fill={color}
        />
        <path
          d="M106.333 64.9333C106.067 65.8666 105.533 68.8 105.4 71.3333C105 75.6 104.6 76 100.067 76.4C94.4667 76.9333 90.7333 80.1333 94.2 81.4666C97.4 82.6666 105.8 81.0666 108.2 78.8C110.6 76.2666 111 64.5333 108.733 63.7333C107.8 63.3333 106.733 63.8666 106.333 64.9333Z"
          fill={color}
        />
        <path
          d="M37.6667 72.2666C30.0667 76.1333 27 82.1333 27 92.8C27 107.333 27.1333 107.333 56.3333 107.333C85.4 107.333 85.6667 107.2 85.6667 93.2C85.6667 85.6 85.4 84.5333 83.4 84.9333C81.5333 85.3333 81 86.9333 80.7333 92C80.6 95.7333 80.4667 99.4666 80.4667 100.4C80.3333 101.733 75 102 56.0667 101.733L31.6667 101.333L31.2667 94.8C30.7333 87.4666 32.6 82.1333 36.6 78.4C38.7333 76.5333 42.2 75.8666 52.7333 75.3333C63.6667 74.8 66.3333 74.2666 66.3333 72.6666C66.3333 69.4666 43.8 69.2 37.6667 72.2666Z"
          fill={color}
        />
      </svg>

      {/* <svg
        width={width}
        height={height}
        viewBox="0 0 138 125"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35 2.5C44.725 2.5 52.5 10.1704 52.5 19.5C52.5 28.8296 44.725 36.5 35 36.5C25.275 36.5 17.5 28.8296 17.5 19.5C17.5 10.1704 25.275 2.5 35 2.5Z"
          stroke={color}
          stroke-width="10"
        />
        <circle cx="88.5" cy="19.5" r="17" stroke={color} stroke-width="10" />
        <circle cx="61.5" cy="58.5" r="17" stroke={color} stroke-width="10" />
        <path
          d="M82.5802 120.114V125H39.9084V120.114H82.5802ZM89.0305 101.545L89.5267 99.5909C90.5191 89.8182 71 85.5 65 86.5L48.8397 86.8864C38.9745 86.8864 32.9618 94.7621 32.9618 104.477V113.273C32.9618 117.051 36.0719 120.114 39.9084 120.114V125L39.6012 124.996C33.2684 124.838 28.1642 119.812 28.0039 113.575L28 113.273V104.477C28 92.0634 36.2341 82 48.8397 82H65.2137C68.5 82 89.5267 87.3711 89.5267 99.5909L90.5191 98.6136L92.5038 99.1023L93 101.545C93 113.273 89.157 125 82.5802 125V120.114C86.4166 120.114 89.0305 105.324 89.0305 101.545Z"
          fill={color}
        />
        <path
          d="M113.288 85.1359V90.1359H104V85.1359H113.288ZM117.288 81.1359V66.1359C117.288 56.1948 107.73 48.6359 97.7884 48.6359H82.4483L100 88.1359C100 86.1359 101 85.1359 104 85.1359V90.1359C100.716 90.1359 100 88.1359 100 88.1359L82.4483 48.6359C82.4483 47.6359 81.8472 43.1359 83.504 43.1359H99.2884C111.991 43.1359 122.288 53.4334 122.288 66.1359V81.1359C122.288 86.1065 118.259 90.1359 113.288 90.1359V85.1359C115.498 85.1359 117.288 83.3451 117.288 81.1359Z"
          fill={color}
        />
        <path
          d="M9.15896 85V90H28.4946V85H9.15896ZM5.93421 81V73.5V66C5.93421 56.0589 14.816 48.5 24.9327 48.5H40.7641L31.8369 87C31.8369 85 31.5475 85 28.4946 85V90C31.837 90 31.8369 87 31.8369 87L40.996 47.5C40.996 46.5 41.1555 43 39.4694 43H23.4062C10.4793 43 -1.69889e-06 53.2975 -1.73167e-06 66V81C-1.73167e-06 85.9706 4.10061 90 9.15896 90V85C7.55263 84.5 5.93421 83 5.93421 81Z"
          fill={color}
        />
        <path
          d="M124.559 54.5316L128.318 58.1292L89.6729 97.8856L86.6393 92.7244L124.559 54.5316ZM124.054 42.1448L122.031 40.0803C117.987 37.4997 116.975 38.0859 114.953 39.5642L74.5048 80.8537C72.988 85.4987 71.5894 91.287 70.5256 97.1599C75.076 96.6438 82.8956 93.7517 86.6393 92.7244L89.6729 97.8856L83.6057 99.434C76.7117 101.451 72.5682 102.222 65.404 103.563L64.8494 103.563L64.4583 103.353L64.3928 102.954L64.3928 102.531C65.404 96.3372 65.9096 92.2083 67.932 84.9826L69.9544 78.2731L108.939 37.8247L109.178 37.5797C114.262 32.512 122.407 32.4809 127.528 37.5698L128.054 38.0929L128.308 38.3518C133.466 43.7443 133.579 52.3315 128.564 57.8635L128.318 58.1292L124.559 54.5316C128.348 50.5585 127.946 46.0126 124.054 42.1448Z"
          fill={color}
        />
        <path d="M107.139 47.0346L119.503 59.6928" stroke={color} stroke-width="8" />
      </svg> */}
    </SvgWrapper>
  );
}
